import { includes } from "@banjoanton/utils";

export const MoveRating = {
    Brilliant: "brilliant",
    Great: "great",
    Best: "best",
    Excellent: "excellent",
    Good: "good",
    Book: "book",
    Inaccuracy: "inaccuracy",
    Mistake: "mistake",
    Miss: "miss",
    Blunder: "blunder",
} as const;

export type MoveRating = (typeof MoveRating)[keyof typeof MoveRating];

export const isMoveRating = (value: string): value is MoveRating =>
    includes(Object.values(MoveRating), value);

export const MoveRatingOrder: MoveRating[] = [
    MoveRating.Brilliant,
    MoveRating.Great,
    MoveRating.Best,
    MoveRating.Excellent,
    MoveRating.Good,
    MoveRating.Book,
    MoveRating.Inaccuracy,
    MoveRating.Mistake,
    MoveRating.Miss,
    MoveRating.Blunder,
];

const moveRatingToSquareColor: Record<MoveRating, string> = {
    brilliant: "rgba(38, 194, 163, 0.5)", // #26c2a3
    great: "rgba(116, 155, 191, 0.5)", // #749BBF
    best: "rgba(129, 182, 76, 0.5)", // #81B64C
    excellent: "rgba(129, 182, 76, 0.5)", // #81B64C
    good: "rgba(149, 183, 118, 0.5)", // #95b776
    book: "rgba(213, 164, 125, 0.5)", // #D5A47D
    inaccuracy: "rgba(247, 198, 49, 0.5)", // #F7C631
    mistake: "rgba(255, 164, 89, 0.5)", // #FFA459
    miss: "rgba(255, 119, 105, 0.5)", // #FF7769
    blunder: "rgba(250, 65, 45, 0.5)", // #FA412D
};

const moveRatingFromSquareColor: Record<MoveRating, string> = {
    brilliant: "rgba(38, 194, 163, 0.35)", // #26c2a3
    great: "rgba(116, 155, 191, 0.35)", // #749BBF
    best: "rgba(129, 182, 76, 0.35)", // #81B64C
    excellent: "rgba(129, 182, 76, 0.35)", // #81B64C
    good: "rgba(149, 183, 118, 0.35)", // #95b776
    book: "rgba(213, 164, 125, 0.35)", // #D5A47D
    inaccuracy: "rgba(247, 198, 49, 0.35)", // #F7C631
    mistake: "rgba(255, 164, 89, 0.35)", // #FFA459
    miss: "rgba(255, 119, 105, 0.35)", // #FF7769
    blunder: "rgba(250, 65, 45, 0.35)", // #FA412D
};

export const moveRatingToTextColor: Record<MoveRating, string> = {
    brilliant: "#26c2a3",
    great: "#749BBF",
    best: "#81B64C",
    excellent: "#81B64C",
    good: "#95b776",
    book: "#D5A47D",
    inaccuracy: "#F7C631",
    mistake: "#FFA459",
    miss: "#FF7769",
    blunder: "#FA412D",
};

export const getMoveRatingColors = (rating: MoveRating) => ({
    to: moveRatingToSquareColor[rating],
    from: moveRatingFromSquareColor[rating],
    text: moveRatingToTextColor[rating],
});
